export var getQuery = function getQuery(state) {
  return state.query;
};
export var getAnalysis = function getAnalysis(state) {
  return state.query.analysisType;
};
export var getEventCollection = function getEventCollection(state) {
  return state.query.eventCollection;
};
export var getTargetProperty = function getTargetProperty(state) {
  return state.query.targetProperty;
};
export var getPercentile = function getPercentile(state) {
  return state.query.percentile;
};
export var getTimeframe = function getTimeframe(state) {
  return state.query.timeframe;
};
export var getTimezone = function getTimezone(state) {
  return state.query.timezone;
};
export var getFunnelSteps = function getFunnelSteps(state) {
  return state.query.steps;
};
export var getGroupBy = function getGroupBy(state) {
  return state.query.groupBy;
};
export var getOrderBy = function getOrderBy(state) {
  return state.query.orderBy;
};
export var getInterval = function getInterval(state) {
  return state.query.interval;
};
export var getLimit = function getLimit(state) {
  return state.query.limit;
};
export var getExtractionPropertyNames = function getExtractionPropertyNames(state) {
  return state.query.propertyNames;
};
export var getExtractionLimit = function getExtractionLimit(state) {
  return state.query.latest;
};
export var getFilters = function getFilters(state) {
  return state.query.filters;
};